import {
  Document,
  Image,
  Page,
  StyleSheet,
  Text,
  View,
  Link,
} from "@react-pdf/renderer";
import { useMemo } from "react";
import { getSymbol } from "../../../../config/helper";
import { amountFormat } from "../../../../utils";
import LogoFooter from "../PDFComponents/LogoFooter";

const ReportDocument = ({
  columns,
  data,
  customFields,
  orientation = "portrait",
}) => {
  const styles = useMemo(
    () =>
      StyleSheet.create({
        page: {
          paddingTop: 20,
          paddingLeft: 10,
          paddingRight: 10,
          lineHeight: 1.5,
          flexDirection: "column",
          position: "relative",
        },
        mainContainer: {
          width: "100%",
          flexDirection: "column",
        },
        Headercontainer: {
          flexDirection: "row",
          backgroundColor: "#E4E4E4",
          alignItems: "center",
          fontStyle: "bold",
          paddingBottom: 5,
          paddingTop: 10,
          paddingLeft: 15,
        },

        header: {
          width: "100%",
          height: 10,
          backgroundColor: "#f48c32",
          flexDirection: "row",
        },

        logoSection: {
          width: "100%",
          paddingTop: 10,
          paddingBottom: 10,
          position: "relative",
          height: 60,
        },
        logoImage: {
          maxHeight: 40,
          width: 100,
          right: 0,
          position: "absolute",
        },
        text: {
          width: `${100 / (columns.length + customFields.length)}%`,
          marginRight: 5,
          fontSize: 8,
          color: "#333333",
        },
        Datacontainer: {
          flexDirection: "row",
          alignItems: "center",
          fontStyle: "bold",
          paddingBottom: 5,
          paddingTop: 10,
          paddingLeft: 15,
          border: "1px solid #E4E4E4",
          borderRadius: 5,
          width: "100%",
          marginTop: 5,
        },
        data: {
          width: `${100 / (columns.length + customFields.length)}%`,
          marginRight: 5,
          fontSize: 8,
          color: "#333333",
          textTransform: "capitalize",
        },
      }),
    [columns, customFields]
  );

  return (
    <Document>
      <Page size="A4" style={styles.page} orientation={orientation}>
        {/* Header */}
        <View style={styles.header}></View>
        {/* Logo Section */}
        <View style={styles.logoSection}>
          <Image style={styles.logoImage} src="/paycraft-logo.png" alt="Paycraft Logo" />
        </View>
        <View style={styles.mainContainer}>
          <View style={styles.Headercontainer}>
            {columns.map((item, index) => (
              <Text key={index} style={styles.text}>
                {item.label}
              </Text>
            ))}
            {customFields.map((ele, index) => (
              <Text key={index} style={styles.text}>
                {ele.replace("_", " ")}
              </Text>
            ))}
          </View>
          {data.map((items, index) => (
            <View key={index} style={styles.Datacontainer}>
              {columns.map((col, idx) => (
                <Text key={idx} style={styles.data}>
                  {col.key?.includes("amount") && items[col.key]
                    ? getSymbol() + " " + amountFormat(items[col.key])
                    : items[col.key] ?? "-"}
                </Text>
              ))}
              {customFields.map((ele, idx) => (
                <Text key={idx} style={styles.data}>
                  {items?.custom_fields?.find((itm) => itm.key === ele)
                    ?.value ?? "-"}
                </Text>
              ))}
            </View>
          ))}
        </View>
        {/* Footer */}

        <LogoFooter />
      </Page>
    </Document>
  );
};

export default ReportDocument;
